import { SalesRepService } from "../SalesRepService/salesrep.service"
import { SalesRepDelegate } from "../SalesRepService/salesrep.delegate"
import { HttpProviderFactory } from '../http/http-provider.factory';
import { SpinnerService } from '../SpinnerService/spinner.service';
import { IAppConfig } from '../http/types/IApplicationConfig';
import { AuthenticationService } from '../AuthenticationService/authentication.service';

export class SalesRepServiceFactory
{
    static create(config: IAppConfig, spinnerService?: SpinnerService,
        authenticationService?: AuthenticationService
    ): SalesRepService
    {
        const httpProvider = HttpProviderFactory.createHttpProvider(config, spinnerService);
        const delegate = new SalesRepDelegate(httpProvider);

        return new SalesRepService(delegate, authenticationService);
    }
}